import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { gql } from "@apollo/client";
import { DateTime } from "luxon";
import { formattedPrice } from "@withfriendsco/wf-components";
gql `
fragment MembershipWithfriendsTransaction on Transaction {
    id
    time
    amount {
        amount
    }
    currencyCode
    paymentStatus
    kind
}
`;
// receiptLink
const MembershipWithfriendsTransaction = ({ withfriendsTransaction, membershipName }) => {
    var _a;
    const createdAt = DateTime.fromSQL(withfriendsTransaction.time);
    const customerMembershipTotal = formattedPrice(((_a = withfriendsTransaction.amount) === null || _a === void 0 ? void 0 : _a.amount) || 0, withfriendsTransaction.currencyCode);
    return (_jsx("div", { className: "leading-loose flex items-center", children: _jsx("span", { children: `${createdAt.toLocaleString()} - ${membershipName}${withfriendsTransaction.kind == 'Addon' ? ' (Addons)' : ''}: ${customerMembershipTotal} - ${withfriendsTransaction.paymentStatus}` }) }));
};
export default MembershipWithfriendsTransaction;
